import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LocationSwitcher from './LocationSwitcher';

const navItems = [
  { path: '/manager', label: 'Dashboard', end: true },
  { path: '/manager/bookings', label: 'Bookings' },
  { path: '/manager/staff', label: 'Staff' },
  { path: '/manager/shifts', label: 'Shift Planner' },
  { path: '/manager/customers', label: 'Customers' },
  { path: '/manager/gift-cards', label: 'Gift Cards' },
  { path: '/manager/reports', label: 'Reports' },
  { path: '/manager/attendance', label: 'Attendance' },
];

export default function ManagerLayout() {
  const { user, logout, isSuperAdmin, isStaff, canClient } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();
  const doLogout = () => { logout(); navigate('/login'); };
  const initials = (user?.firstName?.[0] || '') + (user?.lastName?.[0] || '');
  const isActive = (path, end) => end ? loc.pathname === path : loc.pathname.startsWith(path);

  return (
    <>
      <div className="mobile-header" style={{ background: '#1A1A2E' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div className="hamburger" onClick={() => setOpen(!open)} style={{ color: '#EDEAE2' }}><span /><span /><span /></div>
          <span style={{ fontFamily: 'var(--rr-font-heading)', fontSize: 17, color: '#C9A84C', letterSpacing: '.04em' }}>Manager Portal</span>
        </div>
      </div>
      <div className={`sidebar-overlay ${open ? 'open' : ''}`} onClick={() => setOpen(false)} />
      <div className="app-container">
        <aside className={`app-sidebar ${open ? 'open' : ''}`} style={{ background: '#1A1A2E', color: '#EDEAE2', padding: '30px 20px 24px', gap: 30 }}>
          <div style={{ padding: '0 8px 22px', borderBottom: '1px solid #2C2C48' }}>
            <div style={{ fontFamily: 'var(--rr-font-heading)', fontSize: 19, letterSpacing: '.03em', color: '#F5F1E6', lineHeight: 1.3 }}>Royal<br />Revitalization</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginTop: 12 }}>
              <div style={{ width: 16, height: 1, background: '#C9A84C' }} />
              <div style={{ fontSize: 9.5, letterSpacing: '.24em', color: '#C9A84C', fontWeight: 600 }}>MANAGER PORTAL</div>
            </div>
          </div>

          <nav style={{ display: 'flex', flexDirection: 'column', gap: 3, padding: '0', flex: 1 }}>
            <LocationSwitcher portalRoles={['manager','franchise_owner']} />
            {navItems.map(item => {
              const active = isActive(item.path, item.end);
              return (
                <NavLink key={item.path} to={item.path} end={item.end} onClick={() => setOpen(false)}
                  style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '11px 14px', borderRadius: 9, color: active ? '#F5F1E6' : '#77778C', background: active ? 'rgba(201,168,76,.12)' : 'transparent', textDecoration: 'none', fontSize: 13.5, fontWeight: active ? 600 : 500, boxShadow: active ? 'inset 3px 0 0 #C9A84C' : 'none', transition: 'all .14s' }}>
                  <span style={{ width: 6, height: 6, borderRadius: 3, background: active ? '#C9A84C' : '#4A4A63' }} />
                  {item.label}
                </NavLink>
              );
            })}
          </nav>

          <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ fontSize: 9.5, fontWeight: 700, letterSpacing: '.14em', color: '#4A4A63', marginTop: 4 }}>SWITCH PORTAL</div>
            {isSuperAdmin &&  <NavLink to="/admin" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Super Admin <span style={{ opacity:.5 }}>→</span></NavLink>}
            {isStaff &&  <NavLink to="/staff" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Staff Portal <span style={{ opacity:.5 }}>→</span></NavLink>}
            {canClient &&  <NavLink to="/" onClick={() => setOpen(false)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '9px 12px', borderRadius: 8, background: 'rgba(255,255,255,.05)', color: '#C7C7D6', fontSize: 13, fontWeight: 600, textDecoration: 'none' }}>Client Portal <span style={{ opacity:.5 }}>→</span></NavLink>}
            <div style={{ display: 'flex', alignItems: 'center', gap: 11, padding: '10px 8px', borderTop: '1px solid #2C2C48', marginTop: 6 }}>
              <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#C9A84C', color: '#1A1A2E', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12.5, fontWeight: 700 }}>{initials}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#EDEAE2' }}>{user?.firstName} {user?.lastName}</div>
                <div style={{ fontSize: 11, color: '#7A7A99' }}>{user?.role?.replace('_', ' ')}</div>
              </div>
              <button onClick={doLogout} style={{ background: 'none', border: 'none', color: '#6C6C8A', cursor: 'pointer', fontSize: 11 }}>Out</button>
            </div>
          </div>
        </aside>
        <main className="app-main" style={{ animation: 'rrFade .28s ease both' }}><Outlet /></main>
      </div>
    </>
  );
}
